<template>
  <div class="detailDiv">
    <div class="contentDiv">
    <div class="goBackDiv">
     <div class="goBack" @click="goBack">返回</div>

    </div>

    <div class="contentBox">
  <div class="newsDetailContent">
      <div class="newsDetailTitle">
        {{noticeDetail.title}}
      </div>
      <div class="newsDetailDate">
        {{noticeDetail.add_date}}
      </div>
      <div class="newsDetailContentHtml" v-html="noticeDetail.profile">
      </div>
  </div>
    </div>


    </div>

  </div>
</template>

<script>
export default {
  name: "coverDetail",
  props: {
   
  },
  data() {
    return {
      noticeDetail:{},
      searchKeyword: "",
      item:{}
    };
  },
  mounted(){
      const newId = this.$route.query.newsId
  this.getNoticeDetail(newId)
  },
  methods: {
  getNoticeDetail(newId){
    this.$API.getNoticeDetail(newId).then(res => {
      this.noticeDetail = res.data
    })
  },
   goBack(){
    const gameId = this.$route.query.id
    sessionStorage.setItem('targetAnchor',this.$route.query.active)
    this.$router.push({
      path: '/ScientificResearch',
      query: { id: gameId }
    });
   }
  }
};
</script>

<style scoped>
.newsDetailDate{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;
color: #444444;
text-align: center;
margin-top: 20px;
}
.newsDetailTitle{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: bold;
font-size: 24px;
color: #444444;
text-align: center;
}
::v-deep .newsDetailContentHtml img{
      max-width: 100%;
      height: auto;
      display: block;
      object-fit: contain;
}
.newsDetailContent{
 }
.buttonBtn{
  display: flex;
  justify-content: space-around;
  margin-top: 150px;
}
.mt5{
  margin-top: 5px;
}

.rightBtn{
  width: 250px;
height: 90px;
background: linear-gradient( 134deg, #11A1FD 0%, #4AC4FB 100%);
border-radius: 4px 4px 4px 4px;
text-align: center;


font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: bold;
font-size: 18px;
color: #FFFFFF;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
cursor: pointer;
}
.leftBtn{
  width: 250px;
height: 90px;
background: linear-gradient( 134deg, #0366F1 0%, #4B93F0 100%);
border-radius: 4px 4px 4px 4px;
text-align: center;


font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: bold;
font-size: 18px;
color: #FFFFFF;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
cursor: pointer;
}
.htmlDiv{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;
color: #5E6A7A;
margin-top: 15px;
}
.topDiv{
  border-bottom: 1px solid #EEEEEE;
  padding-bottom: 30px;
  margin-bottom: 30px;
}
.mr120{
  margin-right: 100px;
}
.w700{
  width: 650px;
  display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;
}
.baseLeft{
  width: 543px;
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;
color: #A5A5A5;
line-height: 30px;
}
.infoDetail{
  display: flex;
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;
color: #444444;
margin-top: 15px;
}
.d1{
  width: 93px;
  height: 24px;
}
.detailTitle{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: bold;
font-size: 24px;
color: #444444;
text-align: center;
margin-bottom: 40px;
}
.contentBox{
  background: #fff;
  border-radius: 4px;
  padding: 40px 80px 80px 80px;
  margin-bottom: 30px;
}
.goBackDiv{
  display: flex;
  justify-content: end;
}
.goBack{
  width: 65px;
height: 36px;
background: #F2FBFF;
border-radius: 3px 3px 3px 3px; 

font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #0366F1;
line-height: 36px;
text-align: center;
margin: 20px 0;
cursor: pointer;
}
.detailDiv {
  min-height: calc(100vh - 230px);
  background-image: url('../../../assets/bg222.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  position: relative;

}
.contentDiv{
  width: 1200px;
  margin: 0 auto;
}
</style>
